import { makeStyles } from '@/styles/theme/tss-react';

const useStyles = makeStyles({
  name: 'SelectedImage',
})(({ typography: { pxToRem } }) => ({
  selectedImage: {
    objectFit: 'cover',
    objectPosition: 'center',
    width: '100%',
    height: '100%',
  },
  hoverSelectedImage: {
    transition: 'transform 0.3s ease-in-out',
    '&:hover': {
      transform: 'scale(1.1)',
    },
  },
  selectedImageContainer: {
    borderRadius: pxToRem(16),
    overflow: 'hidden',
    aspectRatio: '1 / 1',
    width: '100%',
    height: 'auto',
  },
}));

export default useStyles;
